import { AwaitContainer } from '@ibsys/kit';
import React from 'react';

import { AppNavigate, RouteConfig, RoutePath } from '@/shared/lib/ts-router';
import { GetDefaultPathCallback } from '@/shared/lib/ts-router/types';
import { useFirstMenuPath } from '@/widgets/MainLayout';

type DefaultPathRouteProps = {
  getDefaultPath: GetDefaultPathCallback;
  /** Дочерние маршруты — из них меню и берёт свои пункты */
  menuItems: readonly RouteConfig[];
};

export const DefaultPathRoute: React.FC<DefaultPathRouteProps> = ({ getDefaultPath, menuItems }) => {
  const { path: firstMenuPath, isResolved } = useFirstMenuPath(menuItems);

  // Уход с адреса необратим: пока не известно, что пользователю видно в меню, ждём
  if (!isResolved) {
    return <AwaitContainer isLoading className="h-full" />;
  }

  const target = getDefaultPath({ firstMenuPath }) as RoutePath;

  return target ? <AppNavigate to={target} replace /> : <AppNavigate to="/" replace />;
};
